
<template>
    <div class="big-img" :class="{hideo:!show,fadeIn:show}" @touchmove.prevent >
        <div class="mask-bg" @click.stop="onClose"></div>
        <div class="content">
            <swiper :options="swiperOption" ref="myswiper" >
                <swiper-slide v-for="(item, index) in imgList" :key="index">
                    <div class="swiper-zoom-container">
                        <img class="slide-img" :src="item" >
                    </div>
                </swiper-slide>
            </swiper>
        </div>
        <div class="page">{{currIndex}}/{{imgList.length||0}}</div>
    </div>
</template>
<script>
import 'swiper/css/swiper.css'
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
export default {
    components: {
        Swiper, SwiperSlide
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        imgList: {
            type: Array,
        },
        currIndex: {
            type: Number,
        },
    },
    data() {
        return {
            swiperOption: {
                zoom: true,
                on: {
                    slideChange: (e) => {
                        this.currIndex = this.$refs.myswiper.$swiper.activeIndex + 1;
                    },
                },
            },
        };
    },
    created() {},
    methods: {
        onClose() {
            this.$emit("update:show", false);
        },
    },
};
</script>
<style scoped>
.mask-bg{
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
}
.big-img {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.9);
    position: fixed;
    left: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.big-img .icon-close {
    position: fixed;
    right: 10px;
    top: 80px;
    padding: 10px;
    width: 42px;
    height: 42px;
}
.big-img .icon-close img{
    width: 22px;
    height: 22px;
}
.big-img .content {
    width: 100%;
    overflow: hidden;
}
.big-img .swiper-zoom-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 300px;
}
.big-img .swiper-zoom-container .slide-img {
    width: 100%;
}
.big-img .page {
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    position: absolute;
    left: 0;
    bottom: 40px;
}
.hideo {
    display: none !important;
}
.fadeIn {
    -webkit-animation: fadeInDown 0.2s forwards;
    animation: fadeInDown 0.2s forwards;
}
 
@keyframes fadeInDown {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
 
@-webkit-keyframes fadeInDown {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
</style>